import {StyleSheet, View} from 'react-native';
import {
  ActivityIndicator,
  Link,
  Text,
  EmphasizedSubText,
} from 'trpc-react-native-ui';

import I18n from '../../../lib/i18n';
import PropTypes from 'prop-types';
import React from 'react';
import theme from '../../../config/themes/kaizen/index';
import TertiaryFullButton from '../FullButtons/TertiaryFullButton';
import SecondaryFullButton from '../FullButtons/SecondaryFullButton';

var styles = StyleSheet.create({
  modalBody: {
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 5,
    maxWidth: 720,
    paddingBottom: 8,
    paddingTop: 20,
  },
  modalButton: {
    flex: 3,
    marginLeft: 5,
    marginRight: 5,
  },
  modalButtonsContainer: {
    flexDirection: 'row',
    padding: 5,
    height: 50,
  },
  modalContent: {
    padding: 20,
  },
  modalContentText: {
    color: theme.defaultTextColor,
    fontSize: 14,
    textAlign: 'center',
  },
  modalTextButton: {
    fontSize: 16,
    padding: 10,
  },
  modalTitle: {
    color: theme.pageTitle.titleColor,
    fontSize: 18,
    fontWeight: '600',
  },
  adviseEmphasis: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  thirdButtonTextStyle: {
    color: theme.secondaryColor,
    fontSize: 14,
    margin: 10,
  },
});

const thirdButtonHandleClick = (onCancel, thirdButtonAction) => {
  thirdButtonAction();
  onCancel();
};

const ConfirmationModalBody = props => {
  const {isLoading = false} = props;
  if (isLoading) {
    return <ActivityIndicator />;
  }

  return (
    <View style={styles.modalBody}>
      {props.title && <Text style={styles.modalTitle}>{props.title}</Text>}
      {props.children}
      <View style={styles.modalContent}>
        <EmphasizedSubText
          style={styles.modalContentText}
          emphStyle={styles.adviseEmphasis}
          text={
            props.confirmContent
              ? props.confirmContent
              : I18n.t('validateToBuy')
          }
        />
      </View>
      <View
        style={styles.modalButtonsContainer}
        testID={'confirmModalButtonsContainer'}>
        <TertiaryFullButton
          text={
            I18n.has(props.cancelText)
              ? I18n.t(props.cancelText)
              : props.cancelText ?? I18n.t('cancel')
          }
          onPress={props.onCancel}
          style={styles.modalButton}
          textStyle={styles.modalTextButton}
        />
        <SecondaryFullButton
          testID="modal-confirm-button"
          text={
            I18n.has(props.confirmText)
              ? I18n.t(props.confirmText)
              : props.confirmText ?? I18n.t('confirm')
          }
          onPress={props.onConfirm}
          style={styles.modalButton}
          textStyle={styles.modalTextButton}
        />
      </View>
      {props.thirdButtonAction && props.thirdButtonText && (
        <Link
          onPress={() =>
            thirdButtonHandleClick(props.onCancel, props.thirdButtonAction)
          }
          text={props.thirdButtonText}
          displayRightArrow={false}
          emphasizeSubText={true}
          style={styles.thirdButtonTextStyle}
        />
      )}
    </View>
  );
};

ConfirmationModalBody.propTypes = {
  isLoading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmContent: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};

export default ConfirmationModalBody;
